import * as React from 'react';
import PropTypes from 'prop-types';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';


function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" color="text.secondary">{`${Math.round(
          props.value,
        )}%`}</Typography>
      </Box>
    </Box>
  );
}

LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};

 function LinearWithValueLabel() {
  const [progress, setProgress] = React.useState(0);


  return (
    <Box sx={{ width: '100%' , height: '5%'}}>
      <LinearProgressWithLabel value={progress} />
    </Box>
  );
}

export default function CircularwithLabel(props) {
  const [progress, setProgress] = React.useState(0);



  return (
    <Box display='flex' justifyContent='center' alignItems='center'>
    <CircularProgress variant="determinate" value={props.value} />
    <Typography position='absolute'>{`${Math.round(
          props.value,
        )}%`}</Typography>
    </Box>
  );
}

CircularwithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};


export {LinearProgressWithLabel, LinearWithValueLabel, CircularwithLabel}